<template>
  <div>
    <div class="container-fluid sky-letter">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="breadcrumbs">
              <a href="/">Главная</a> / <a href="https://poliglotiki.com/home-teacher/onlineteacher">OnlineTeacher</a> / Индивидуальные онлайн занятия по английскому языку
            </div>

            <h1 class="desktop-vers">Английский <span class="yellow-blue">онлайн индивидуально</span></h1>
            <h1 class="mobile-vers">Английский<br> <div class="yellow-blue">онлайн<br> индивидуально</div></h1>
            <img src="~@/assets/hometeacher/images/noteboy.png" alt="Индивидуальные онлайн занятия по английскому языку" class="childs">

            <h3>для современных детей от 12 месяцев до 12 лет</h3>

            <p>Знания английского языка &ndash; <span class="strong-black">прочный фундамент успешного будущего детей</span>. Подайте заявку, и мы подберем программу и преподавателя специально для ваших целей. Заложим основы языка, сформируем мотивацию к учебе, подготовим к экзаменам, научимся общаться в путешествиях.</p>

            <p><span class="strong-black">Ставьте цель, мы поможем ее достичь!</span></p>

            <div class="knpk"><a href="https://poliglotiki.com/home-teacher/individual">Подать заявку</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid sky-wave"></div>
    <div class="container-fluid sky-clouds no-shadow">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-8">
            <h2 class="iba desktop-vers">Иностранный язык <span class="sdostavkoj">с доставкой</span></h2>
            <h2 class="iba mobile-vers">Иностранный язык <div class="sdostavkoj">с доставкой</div></h2>
            <img src="~@/assets/hometeacher/images/girl-clouds.png" alt="Индивидуальные онлайн занятия по английскому языку" class="twokinds mobile-vers">
            <p class="leftp" ><span class="strong-black">Мы стираем границы!</span></p>
            <p class="leftp" style="max-width: 650px;">Занимайтесь с педагогом онлайн <span class="strong-black">из любой точки мира</span>, в любом городе и стране.</p>
            <p class="leftp" style="max-width: 650px;"><span class="strong-black">Мы обучаем через Интернет</span> &ndash; поэтому подключайтесь к индивидуальному занятию из дома, в машине, на даче, на отдыхе за границей или у бабушки в деревне.</p>
            <p class="leftp" style="margin-bottom: 40px;"><span class="strong-black">Через смартфон или планшет</span> с устойчивой связью от 1 Мбит/сек.</p>
            <div class="chek"></div><p>Интенсивность и график индивидуальных занятий для ребенка родители определяют совместно с педагогом.</p>
            <div class="chek"></div><p>Обучение проводится полностью на английском языке.</p>
          </div>

          <div class="col-12 col-sm-4">
            <img src="~@/assets/hometeacher/images/girl-clouds.png" alt="Индивидуальные онлайн занятия по английскому языку" class="twokinds desktop-vers">
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid liniya mobile-vers"></div>
    <div class="container-fluid no-shadow par fr-page">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-4">
            <img src="~@/assets/hometeacher/images/girlchik.jpg" alt="Индивидуальные онлайн занятия по английскому языку" class="birdskids desktop-vers">
          </div>
          <div class="col-12 col-sm-8 pdlft80px">
            <h2 class="iba desktop-vers"><span class="gryelgrn">Индивидуальный</span> график и темп</h2>
            <h2 class="iba mobile-vers"><span class="gryelgrn">Индивидуальный</span><br> график и темп</h2>
            <img src="~@/assets/hometeacher/images/girlchik.jpg" alt="Индивидуальные онлайн занятия по английскому языку" class="birdskids mobile-vers">
            <p class="leftp">Посещайте занятия в <span class="strong-black">комфортное для вас время:</span> по личному графику, согласованному с педагогом.</p>

            <p class="leftp desktop-vers" style="margin-bottom: 40px;"><span class="skyspan"><span class="strong-black">Индивидуальное расписание &ndash; это одно из главных преимуществ</span></span><br>
              <span class="skyspan"><span class="strong-black">онлайн-обучения в OnlineTeacher.</span></span> </p>

            <div class="bluefon mobile-vers"><p class="leftp"><span class="strong-black">Индивидуальное расписание &ndash; это одно из главных преимуществ онлайн-обучения в OnlineTeacher.</span></p></div>

            <div class="chek"></div><p>Расписание может быть <span class="strong-black">гибким и меняться под вас</span>.</p>
            <div class="chek"></div><p><span class="strong-black">Ребенок учится в своем ритме</span> &ndash; активность ребенка задает темп прохождения всего выбранного курса.</p>

          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid liniya mobile-vers"></div>
    <div class="container-fluid small-strelki no-shadow pdtop50px">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="iba desktop-vers">Ставьте цели <span class="igraya">и выбирайте программу</span></h2>
            <h2 class="iba mobile-vers">Ставьте цели <div class="igraya">и выбирайте программу</div></h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-8">
            <img src="~@/assets/hometeacher/images/noteklava.png" alt="Индивидуальные онлайн занятия по английскому языку" class="twokinds mobile-vers">
            <p class="leftp" style="max-width: 650px;">Вам не придется догонять группу, если пропущен урок или отстали по программе. <span class="strong-black">Мы восполним все пробелы в знаниях.</span></p>
            <p class="leftp mrgtopbtn desktop-vers"><span class="skyspan"><span class="strong-black">На индивидуальных уроках всё время уделяется одному ребенку.</span></span></p>
            <div class="bluefon mobile-vers"><p class="leftp"><span class="strong-black">На индивидуальных уроках всё время уделяется одному ребенку.</span></p></div>
            <p class="leftp" style="margin-bottom: 30px; max-width: 590px;">Перед занятиями преподаватель составляет индивидуальный план занятий с учетом сильных и слабых сторон ребенка.</p>

            <div class="chek"></div><p>Требуется закрепить сложную тему &ndash; <span class="skyspan"><span class="strong-black">закрепим.</span></span></p>
            <div class="chek"></div><p>Не получается аудирование &ndash; <span class="skyspan"><span class="strong-black">наверстаем.</span></span></p>
            <div class="chek"></div><p>Трудности с произношением &ndash; <span class="skyspan"><span class="strong-black">исправим.</span></span></p>
            <div class="chek"></div><p>Нужны интенсивные занятия &ndash; <span class="skyspan"><span class="strong-black">организуем!</span></span></p>
          </div>

          <div class="col-12 col-sm-4">
            <img src="~@/assets/hometeacher/images/noteklava.png" alt="Индивидуальные онлайн занятия по английскому языку" class="twokinds desktop-vers">
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid skytop"></div>
    <div class="container-fluid skyfon">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h2>С “Полиглотиками”<br> учить иностранный язык — <br>
              <span class="veselo">весело и интересно!</span></h2>
          </div>

          <div class="col-12 col-sm-5">
            <img src="~@/assets/hometeacher/images/strlka.png">
            <div class="knpk-yellow"><a href="https://poliglotiki.com/home-teacher/entry">Бесплатная консультация</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid skydown"></div>

    <div class="container-fluid fon-krugi">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h2 class="iba desktop-vers">Программы &ndash;<br> <span class="uvlek">от простого к сложному </span></h2>
            <h2 class="iba mobile-vers">Программы &ndash;<br> <div class="uvlek">от простого <br>к сложному </div></h2>
            <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img src="~@/assets/hometeacher/images/programmki-mob.jpg" alt="Индивидуальные онлайн занятия по английскому языку" class="programmki"></div>
            <p class="px20" style="font-size: 25px;"><span class="strong-black">Начните заниматься с любого уровня.</span></p>
            <p class="px20">Мы подберем курс английского <span class="strong-black">индивидуально под вашего ребенка</span>.</p>
            <p class="px20"><span class="strong-black">Авторские программы</span> сети детских языковых центров «Полиглотики» адаптированы под онлайн-формат OnlineTeacher, <span class="strong-black">наполнены игровыми элементами и увлекают детей</span>.</p>
            <p class="px20">Наши занятия направлены на <span class="strong-black">развитие и совершенствование навыков</span> говорения, аудирования, чтения, письма, проработку лексики и грамматики.</p>
            <p class="px20">При переходе на следующий уровень обучения программа усложняется.</p>

            <div class="gradyelblue"><p>Наши педагоги, многие из которых являются<br>
              носителями языка, гарантируют эффективность<br>
              занятий, вовлечение в процесс и полное<br>
            погружение в изучаемый язык. </p></div>
          </div>
          <div class="col-12 col-sm-5">
            <img src="~@/assets/hometeacher/images/programmki.png" alt="Индивидуальные онлайн занятия по английскому языку" class="programmki desktop-vers">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="px20">Благодаря этому происходит быстрое и качественное усвоение материала.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid bigwavetop desktop-vers"></div>
    <div class="container-fluid liniya mobile-vers"></div>
    <div class="container-fluid think">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-8">
            <h2 class="iba desktop-vers"><span class="otkritost">Открытость и качество</span></h2>
            <h2 class="iba mobile-vers"><div class="otkritost">Открытость<br> и качество</div></h2>
            <img src="~@/assets/hometeacher/images/think-sky-img.png" alt="Индивидуальные онлайн занятия по английскому языку" class="mobile-vers">
            <p class="leftp" style="max-width: 600px;">Онлайн-занятия проходят в открытом для родителей формате. <span class="strong-black">Наблюдайте за процессом обучения</span>. А с совсем маленьким ребенком выполняйте задания на английском языке <span class="strong-black">вместе</span>.</p>
            <p class="leftp" style="max-width: 630px;">Задавайте вопросы педагогу после каждого занятия и <span class="strong-black">получайте обратную связь</span>.</p>
            <p class="leftp" style="max-width: 650px;">В OnlineTeacher мы не просто изучаем иностранный язык &ndash; <span class="strong-black">дети расширяют кругозор</span>, узнают о культуре и традициях стран, <span class="strong-black">тренируют</span> критическое мышление и креативность, <span class="strong-black">развивают</span> интеллектуальные способности. </p>
            <p class="leftp mrgtopbtn desktop-vers"><span class="skyspan"><span class="strong-black">Индивидуальные занятия проводится с полноценными</span></span><br>
              <span class="skyspan"><span class="strong-black">домашними заданиями, контролем их выполнения и оценкой</span></span><br>
              <span class="skyspan"><span class="strong-black">качества знаний.</span></span></p>
            <div class="bluefon mobile-vers" style="margin-bottom: -50px;"><p class="leftp"><span class="strong-black">Индивидуальные занятия проводится с полноценными домашними заданиями, контролем их выполнения и оценкой качества знаний.</span></p></div>

          </div>

          <div class="col-12 col-sm-4">
            <img src="~@/assets/hometeacher/images/think-sky-img.png" alt="Индивидуальные онлайн занятия по английскому языку" class="desktop-vers">
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid bigwavebottom desktop-vers"></div>
    <div class="container-fluid liniya mobile-vers"></div>
    <div class="container-fluid stars">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h2 class="iba desktop-vers">Развиваем<span class="bezlimit">навыки 21 века</span></h2>
            <h2 class="iba mobile-vers">Развиваем<div class="bezlimit">навыки 21 века</div></h2>
            <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;">
              <img src="~@/assets/hometeacher/images/stars-sky-img-mob.jpg" alt="Индивидуальные онлайн занятия по английскому языку">
            </div>
            <p class="leftp">Детям с рождения знакомы смартфоны и компьютеры. Они окружают нас ежедневно.</p>
            <p class="leftp">На индивидуальных онлайн-занятиях мы совмещаем приятное с полезным, превратив <span class="strong-black">гаджет из «игрушки» в развивающий интерактивный Центр!</span></p>
            <p class="leftp">Получайте удовольствие от увлекательного процесса обучения английскому в OnlineTeacher.</p>
            <p class="leftp" style="font-size: 30px; margin-bottom: 40px;"><span class="strong-black">Чтобы ребенку было действительно интересно, мы используем:</span></p>

            <div class="chek"></div><p><span class="strong-black">Удерживающие внимание</span> короткие мультфильмы и иллюстрации</p>
            <div class="chek"></div><p><span class="strong-black">Раскраски, задания на мониторе</span> в подаче педагога</p>
            <div class="chek"></div><p><span class="strong-black">Двигательные разминки</span> на иностранном языке</p>
            <div class="chek"></div><p>Интерактивные озвученные <span class="strong-black">тренажеры, игры-тесты, загадки</span>.</p>
          </div>

          <div class="col-12 col-sm-5">
            <img src="~@/assets/hometeacher/images/stars-sky-img-png.png" alt="Индивидуальные онлайн занятия по английскому языку" class="desktop-vers">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <img src="~@/assets/hometeacher/images/clock-sky.png" class="desktop-vers clock-img">
            <p class="leftp clock-text full"><span class="prodolz-1">Продолжительность 1 индивидуального онлайн-занятия  <span class="strong-black">&ndash; от 30 до 60 минут ,</span></span><br>
              <span class="prodolz-2">в зависимости от возраста ребенка.</span></p>
            <div class="prodolz">
              <p class="leftp clock-text">Продолжительность 1<br> индивидуального<br> онлайн-занятия  <span class="strong-black">— от 30<br> до 60 минут</span> ,<br> в зависимости от<br> возраста ребенка.</p>
              <img src="~@/assets/hometeacher/images/clock-sky.png" class="mobile-vers clock-img">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid skytop" style="margin-top: 40px;"></div>
    <div class="container-fluid skyfon">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h2>Индивидуальные занятия английским &ndash; правильный выбор, если вы цените</h2>
              <h2 class="personal">персональный подход!</h2>
            <p class="desktop-vers">&nbsp;</p>
          </div>

          <div class="col-12 col-sm-5">
            <img src="~@/assets/hometeacher/images/strlka.png">
            <div class="knpk-yellow"><a href="https://poliglotiki.com/home-teacher/entry">Бесплатная консультация</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid skydown"></div>

    <div class="container-fluid produman">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="iba desktop-vers"><span class="oformite">Оформите абонемент сейчас</span></h2>
            <h2 class="iba mobile-vers"><div class="oformite">Оформите абонемент сейчас</div></h2>
            <p class="leftp">Наш специалист свяжется с вами для согласования графика обучения.</p>
            <SubscriptionsList v-if="subscriptions"
                               :subscriptions="subscriptions"
                               @order="orderSubscription"
                               @bonusCourseClick="bonusCourseClick"
            />
            <div class="groupzan"><a href="https://poliglotiki.com/home-teacher/anglijskij-onlajn-v-gruppe">Групповые занятия &rarr;</a></div>

          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid bigwavetop desktop-vers"></div>
    <div class="container-fluid liniya mobile-vers"></div>
    <div class="container-fluid white-bg fr-page no-shadow kak-pr">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <h2 class="iba"><span class="kak">Как проходят</span> онлайн-занятия</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <carousel :responsive="{0:{items:1},1000:{items:2}}">
              <div class="centers-text mx-3">
                <a href="/images/gall-1.jpg" target="_blank"><img src="@/assets/hometeacher/images/gall-1.jpg" class="zanat"></a>
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-2.jpg" class="zanat">
              </div>

              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-3.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-4.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-5.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-6.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-7.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-8.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-9.jpg" class="zanat">
              </div>
              <div class="centers-text mx-3">
                <img src="@/assets/hometeacher/images/gall-10.jpg" class="zanat">
              </div>
            </carousel>
          </div>
        </div>

        <div class="row kakimg">
          <div class="col-12 col-sm-6">
            <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                    src="https://www.poliglotiki.ru/embed/KnlzTavUb38" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <div class="col-12 col-sm-6">
            <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                    src="https://www.poliglotiki.ru/embed/RUu5Y6MkosI" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
        </div>
        <div class="row kakimg">
          <div class="col-12 col-sm-6">
            <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                    src="https://www.poliglotiki.ru/embed/grdB0RPsaOs" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <div class="col-12 col-sm-6">
            <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                    src="https://www.poliglotiki.ru/embed/42MC62cDy00" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>


    <div class="container-fluid liniya"></div>
    <div class="container-fluid white-bg centers-list fr-page no-shadow" style="padding-top: 25px;">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <h2><span class="strong-black">Отзывы об онлайн-уроках</span></h2>
            <p>&nbsp;</p>
          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nataliya-yuferova.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">24.05.2021</span>
            <span class="nameotzyv">Наталия Юферова <a href="https://vk.com/id4037847" target="_blank">vk.com</a></span><br>

            <span class="textotzyv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года. Дочке было 5 лет, ранее знакомства с английским языком не было. На Полиглотиков наткнулась случайно: заинтересовал он-лайн формат обучения при многообразии уроков. Я всегда за обучение в формате игр, а тут и music class, и story time, и art class. На первый урок попали к Виктории, с нами были ещё несколько ребят, которые уже ориентировались в английском. Хочу сразу сказать огромное спасибо преподавателям за их чуткость к детям, заинтересованность в их обучении, благожелательность, жизнерадостность и внимание! Спасибо за то, что прививаете любовь к языкам нашим детям! Сразу скажу, что дочка первые занятия не понимала и не запоминала слова, но была увлечена, с нетерпением ждала уроков, и правильный ответ для неё был маленькой победой! Мне в свою очередь было очень удобно он-лайн обучение: мы были на дистанционной работе, а ребёнка можно было просто посадить рядом и подсказывать при необходимости. Сейчас это также удобно, потому что если мы не успеваем, то подключиться к уроку дочка может или сама, или бабушка поможет, не нужно никуда собираться и ехать. А иногда я занимаюсь домашними делами, а ребёнок рядом занимается. При этом мы, родители, знаем, что дети проходят, можем помочь, повторить слова, вводить их в повседневный разговор, скачать изучаемые песни, чтобы вместе попеть, почитать книжку на русском, ту, которую читали на английском на уроках (это просто огромный плюс). А ещё дети неохотно отрываются от своих игр и маленьких дел даже ради любимых занятий, а тут можно даже игрушки не убирать, просто переместиться за стол, а по окончании вернуться в игру. По самим урокам: мне нравится наполненность, дозированность информации в сочетании с переменками в виде песенок с движениями-дети не успевают ни заскучать, ни устать. Поделки с art класса мы носили в садик, дарили в виде новогодних подарков родственникам - темы поделок всегда актуальны. Ещё раз спасибо всем нашим преподавателям! И за обратную связь! Как результат занятий - дочка может пройти этап знакомства, ответить на вопросы о любимых игрушках/блюдах/цветах, рассказать о погоде и описать человека, а ещё спеть пару песенок на английском, но под фонограмму :))) и выдать слова, которые мы вроде не проходили, но встречали на уроках story time. Надеюсь, что дальше будет только увлекательнее и интереснее.</span>

          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/nadya-brandaus.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">21.05.2021</span>
            <span class="nameotzyv">Nadya Brandaus <a href="https://vk.com/id294529857" target="_blank">vk.com</a></span><br>

            <span class="textotzyv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника. Для меня удивительно, почти час ребёнок погружен в процесс, слушает и отвечает с удовольствием. Преподаватели - просто волшебники! Моя дочь очень застенчива, легко отвлекается, до этого мы пробовали несколько курсов, где не получалось. «Полиглотики» придали ребёнку самоуверенности. Дочка выучила много новых слов и выражений, стала разговаривать и напевать на английском. Мы очень рады, что нашли вас! Удачи всем!</span>

          </div>
        </div>

        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt="" src="@/assets/hometeacher/images/no-avatar-1.png"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">20.05.2021</span>
            <span class="nameotzyv">Olia Foro <a href="https://vk.com/o.foro" target="_blank">vk.com</a></span><br>

            <span class="textotzyv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ, но у ребенка пропадал интерес после нескольких уроков. Но попав в эту школу, мы остаёмся тут на долго. Прекрасные преподаватели, которые умеют увлечь маленьких непосед, служба поддержки, которая всегда на связи и оперативно отвечает на все запросы, огромное количество различных занятий. Ребенок с нетерпением ждет каждого урока, всегда есть обратная связь, групповые занятия проходят очень весело и продуктивно. Всегда учитываются пожелания клиента. Очень рады быть с Вами!!!</span>

          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/vera-kondrateva.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">18.05.2021</span>
            <span class="nameotzyv">Вера Кондратьева <a href="https://www.facebook.com/profile.php?id=100008304612517" target="_blank">facebook.com</a></span><br>

            <span class="textotzyv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей, ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу https://poliglotiki.com для изучения англ языка.<br>
                      Уроки проходят с понедельника по субботу 2 раза в день, группы представлены разные от 3 до 17 лет, причем мы живем в Доминикане и по нашему часовому поясу занятия также проходят в 10,11.12,13 по местному, т.е. вечером по Москве. Занятия классные, в игровой форме, для начинающих деток проходит обучение в форме игры, занятий по рисованию, чтение сказок, поем песенки и ВСЕ на англ. Для нас это выход, ребенок общается с другими детьми, постоянно слушает англ речь. Цены не просто доступные, а супердоступные. Первые 3 дня бесплатно, смотрите, пробуете. Мы намучались выбирая разные платформы и способы обучения, многие просто берут неадекватные деньги за те же самые услуги, устраивает все от качества,формы преподования, до цены и внеурочного общения с менеджерами. Это лучшая платформа, что мы встречали по изучению англ языка, там есть и другие языки, но мы пока учим англ. Хотела поделиться с теми, кто также как мы давно ищет нечто подобное и не может найти, я как мать двоих детей, обучающая своих детей дома, понимаю и знаю как это тяжело, поэтому решила сделать здесь пост, кому то надеюсь очень поможет, а вы когда нибудь поделитесь тоже чем то интересным и так общими усилиями будем помогать друг друг в этом нелегком дете воспитания наших деток. Я не менеджер ответов на вопросы не даю, если есть вопросы пишите им лично, сайт я указала. Всем хорошего дня!!</span>

          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/elena-serebryakova.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">27.02.2021</span>
            <span class="nameotzyv">Елена Серебрякова <a href="https://vk.com/id426090428" target="_blank"
                                                         rel="nofollow">vk.com</a></span><br>

            <span class="textotzyv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского. Дети всегда могут обратиться и на русском, и на английском языках. В занятиях красочные задания, песни; преподаватели всегда интересуются качеством связи, чтобы слышать всех учеников. Поправляют ошибки вежливо, без придирок, всегда обращают внимание на правильность произношения. Занятий много в расписании, можно посещать любые. Преподаватели знакомятся с каждым ребенком, нет чувства, что занимаешься с чужим человеком. К каждой теме, есть тематическая песня. На музыкальных занятиях изучают песни, по строчкам проговаривая текст.</span>
          </div>
        </div>

        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/marina-fedorina.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">22.01.2021</span>
            <span class="nameotzyv">Марина Федорина <a href="https://vk.com/id42068522" target="_blank"
                                                       rel="nofollow">vk.com</a></span><br>

            <span class="textotzyv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от  #полиглотиков.<br>
                    Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре в школу, а учитель английского заболела, а потом и мы все заболели. Начала я искать, где можно английский подтянуть. Все заведения по дополнительному образованию в городе закрыты из-за карантина. Наткнулась на #полиглотиков, там как раз была акция 2 недели бесплатного обучения с онлайн учителем по зуму. Решили попробовать, вроде, понравилось. Миша «ходит» в группу для младших школьников. Вначале слова учили по темам, сейчас грамматика пошла. Втянулся, раньше спрашивал, когда занятия, сейчас сам уже всё расписание выучил, лучше меня знает. В школе тоже пятёрки «пошли» по английскому.<br>
                    Среднего из садика тоже на карантин «высадили», кружки все на дистанционном обучении, только задания присылают. А когда с ним все занятия выполнять… Хотелось, чтобы сам иногда занимался. Решили с Максимом тоже английский начать учить. Записала его в группу для начинающих возраст 5-6 лет. И не пожалела. Сейчас, через 3 месяца уже отвечает на вопросы о себе, о семье может немного рассказать, цвета знает и счёт до 10. Хотя до этого вообще английский не учил. Нравится, как преподаватель с ними работает, слова наглядно на картинках плюс подписаны на английском идёт зрительное и слуховое запоминание. Песенку в начале каждого занятия поют, уже вся семья выучила) Игры разнообразные на закрепление слов. У Максима азарт такой во время игры, первый раз даже не поняла, почему он у меня там кричит во время занятия.<br>
                    Единственное, мне кажется, Максиму не хватает начальных знаний, типа изучение алфавита. И время не всегда удобное, у нас 2 часа разница с московским, занятия иногда в 9 вечера. На курсе 2 варианта занятия днём в 12-13 и вечером в 8-9 вечера. Когда сидим дома, занимаемся днём, когда в садик ходим, то вечером. Хотя что Миша, что Максим готовы на все занятия ходить… и днём и вечером.<br>
                    Программа, в которой проходят занятия простая. 6-летний сын сам разобрался, что где включать.<br>
                    Учителя замечательные, хвалят, подбадривают, стараются всем внимания уделить. В дневных группах мало народа, иногда 1-2 человека занимаются, получается индивидуальное занятие, в вечерних больше — по 6-8 в среднем. В общем, всем, кто хочет поднятуть ребёнка по английскому, или начать изучать очень советую онлайн-курс от #полиглотиков «OnlineTeacher».<br>
                    Ах, да, ещё кроме основных занятий есть дополнительные «Арт класс», «мьюзик класс» и «стори тайм», где дети мастерят, рисуют, поют песни и слушают истории. Занятия проходят легко и весело. Спасибо всем преподавателям школы #полиглотиков.</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import moment from 'moment';
import SubscriptionsList from "./Subscriptions/SubscriptionsList";
import subscriptionApi from "../data/SubscriptionApi";
import {isAuthenticated} from "../data/jwt.service";
import userApi from "../data/UserApi";

export default {
  components: {
    carousel,
    SubscriptionsList,
  },
  name: "AnglijskijOnlajnIndividualno",

  data: function () {
    return {
      title: null,
      subscriptions: null,
    }
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    this.loading = true

    if (isAuthenticated()) {
      userApi.fetchProfile()
              .then(response => {
                //Исключаем одноразовые промо подписки
                let ids = response.oneOffSubscriptionIds
                subscriptionApi.fetchIndividualSubscriptions()
                        .then(response => {
                          this.subscriptions = response.filter(s => { return ids.indexOf('' + s.idsubscription) === -1 && s.subscription.startsWith('Английский') })
                        })
                        .catch(error => {
                          let data = error.response.data
                          this.error = this.pretty(data)
                          this.loading = false
                        })
              })
              .catch(error => {
                let data = error.response.data
                this.error = this.pretty(data)
                this.loading = false
              })
    } else {
      subscriptionApi.fetchIndividualSubscriptions()
              .then(response => {
                this.subscriptions = response.filter(s => {return s.subscription.startsWith('Английский') })
              })
              .catch(error => {
                let data = error.response.data
                this.error = this.pretty(data)
                this.loading = false
              })
    }

  },

  methods: {
    orderSubscription(subscription) {
      this.$router.push('/subscription/order/' + subscription.idsubscription)
    },

    bonusCourseClick(subscription) {
      if (subscription.courses.length > 0) {
        this.$router.push('/course/' + subscription.courses[0].slug)

      }
    },
  },

  metaInfo() {
    return {
      title: 'Индивидуальные онлайн занятия по английскому языку',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Индивидуальное онлайн обучение детей от 12 месяцев до 12 лет английскому языку.'
        }
      ]
    }
  },
}
</script>

<style scoped>

.sky-letter {
  background: url(~@/assets/hometeacher/images/sky-letter.jpg) repeat-y center top;
  /*min-height: 650px;*/
  margin-top: 0px;
  padding-bottom: 20px;
  box-shadow: inset 0 3px 5px #00000038;
}

.sky-wave {
  background: url(~@/assets/hometeacher/images/sky-wave.jpg) no-repeat center;
  width: 100%;
  height: 149px;
  margin-top: -2px;
}

.breadcrumbs {
  font-size: 14px;
  background: #fff;
  max-width: 550px;
  padding-left: 5px;
  border-radius: 10px;
}

.sky-letter h1 {
  font-size: 50px;
  font-family: Manrope Black;
  margin-top: 15px;
  margin-bottom: 0px;
  color: #000;
}

.sky-letter h3 {
  font-size: 30px;
  font-family: Manrope Bold Alt;
  color: #000;
  margin-bottom: 40px;
}

.yellow-blue {
  background-image: url(~@/assets/hometeacher/images/yellow-blue.png);
  padding-left: 10px;
  padding-bottom: 8px;
  padding-right: 10px;
}

.sky-letter p {
  font-size: 20px;
  max-width: 670px;
  line-height: 1.4;
}

.childs {
  float: right;
  margin-right: -100px;
  margin-left: -38px;
  margin-top: -10px;
}

.knpk {
  border-radius: 35px;
  max-width: 230px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear, left bottom, left top, from(#02a1d6), to(#26c8ff));
  font-size: 22px;
  color: #fff;
  padding: 15px 30px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
  margin-top: 35px;
}

.knpk:hover {
  background: #02a1d6;
}

.knpk-down:hover {
  background: #39ab22;
}

.knpk a, .knpk-down a {
  color: #fff;
}

.pdtop50px {
  padding-top: 50px;
}

.iba {
  font-family: Manrope Bold Alt;
  font-size: 40px;
  color: #000;
  margin-bottom: 40px;
}

.mrgtopbtn {
  margin-bottom: 20px;
  margin-top: 20px;
}

.sky-clouds {
  background: url(~@/assets/hometeacher/images/sky-clouds.png) no-repeat center top;
  margin-top: -10px;
  min-height: 790px;
  margin-bottom: 40px;     padding-top: 60px;
  box-shadow: inset 0 3px 5px #00000038;
}

.sky-clouds p, .small-strelki p, .listochki p, .think p, .stars p, .produman p, .par p {
  font-size: 20px;
  margin-left: 60px;     color: #000;
}

.par h2 {width:675px; margin-bottom: 60px;}

.sdostavkoj {
  background-image: url(~@/assets/hometeacher/images/sdostavkoj.png);
  padding-left: 8px;
  padding-bottom: 2px;    padding-top: 2px;
  padding-right: 8px;
}

.px20 {
  font-size: 20px;    color: #000;
  margin-top: 25px !important;
}

.chek {
  background: url(~@/assets/hometeacher/images/sky-chek.png) no-repeat top left;
  font-size: 20px;
  float: left;
  width: 25px;
  height: 20px;
  margin-top: 8px;
  margin-left: 25px;
}

.chek p {
  font-size: 20px;
}

.twokinds {
  margin-top: 20px;
}

.birdskids {
  margin-left: -50px;
  margin-top: 50px;
}

/*.mgtop130 {margin-top: 130px;}*/

.gryelgrn {
  background-image: url(~@/assets/hometeacher/images/individ-fon.png);
  padding-left: 8px;
  padding-bottom: 10px;
  padding-right: 8px;
}

.leftp {
  margin-left: 0px !important;
}

.skyspan {
  background: #d0f4fe;
  padding: 3px 10px;
  border-radius: 17px;
  color: #000;
}

.pdlft80px {
  padding-left: 80px;
}

.small-strelki {
  background: url(~@/assets/hometeacher/images/sky-strelki.png) no-repeat center top;
  min-height: 710px;
  margin-top: 0px;
  padding-bottom: 40px;
  box-shadow: inset 0 3px 5px #00000038;
}

.igraya {
  background-image: url(~@/assets/hometeacher/images/vibirajte.png);
  padding-left: 8px;
  padding-bottom: 10px;
  padding-right: 8px;
}


.bigwavetop {
  background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
  width: 100%;
  height: 190px;
 /* margin-top: -50px;*/
}

.bigwavebottom {
  background: url(~@/assets/hometeacher/images/bigwavebottom.png) no-repeat center;
  width: 100%;
  height: 186px;
  margin-top: -80px;
}


.listochki h2 {
  max-width: 450px;
}

.fon-krugi {
  background: url(~@/assets/hometeacher/images/fon-krugi.png) no-repeat center;
  width: 100%;
  min-height: 744px;
  margin-top: -25px;
  padding-top: 130px;
}

.programmki {
  margin-top: -35px;
}

.uvlek {
  background-image: url(~@/assets/hometeacher/images/otprostogo.png);
  padding-left: 8px;
  padding-top: 2px; padding-bottom: 10px;
  padding-right: 10px;
}

.think {
  background: url(~@/assets/hometeacher/images/think-sky.png) no-repeat center;
  width: 100%;
  min-height: 780px;
  margin-top: -25px;
  padding-top: 130px;
}
.think img {margin-top: 80px;}

.stars {
  background: url(~@/assets/hometeacher/images/stars-sky.png) no-repeat center;
  width: 100%;
  min-height: 1060px;
  margin-top: -170px;
  padding-top: 230px;
}
.stars img {margin-top: 170px;}
.stars h2 {padding-top: 50px;}
.prodolz-1 {
  background-image: url(~@/assets/hometeacher/images/prodolz-1.png);
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 8px;
  padding-right: 13px;
}
.prodolz-2 {
  background-image: url(~@/assets/hometeacher/images/prodolz-2.png);
  padding-left: 10px;
  padding-top: 1px;
  padding-bottom: 8px;
  padding-right: 6px;
}
.clock-img {position: absolute;
  top: 30px;
  margin-top: 0px !important;
  left: 980px;}
.clock-text {font-size: 25px !important;margin-top: 50px;}

.otkritost {
  background-image: url(~@/assets/hometeacher/images/otkrit.png);
  padding-left: 8px;
  padding-top: 2px;
  padding-right: 8px;
}

.bezlimit {
  background-image: url(~@/assets/hometeacher/images/naviki.png);
  padding-left: 8px;
  padding-top: 2px;
  padding-right: 8px;
}

.skytop {
  background: url(~@/assets/hometeacher/images/skytop.jpg) no-repeat center;
  width: 100%;
  height: 56px;
}

.skydown {
  background: url(~@/assets/hometeacher/images/skydown.jpg) no-repeat center;
  width: 100%;
  height: 61px;
}

.skyfon {
  background: url(~@/assets/hometeacher/images/skyfon.png) repeat-y center;
  min-height: 290px;
  overflow: hidden;
}

.skyfon img {
  float: right;
  margin-right: -401px;
  margin-top: 107px;
  height: 33px;
  max-width: 100%;
}

.skyfon h2 {
  font-family: Manrope Bold Alt;
  font-size: 40px;
  color: #fff;
  margin-top: 50px;
  line-height: 1.3;
}

.veselo {
  background-image: url(~@/assets/hometeacher/images/veselo-sky.png);
  padding-left: 8px;
  padding-top: 2px; padding-bottom: 8px;
  color: #000;
  padding-right: 8px;
}

.personal {
  background-image: url(~@/assets/hometeacher/images/personal.png);
  padding-left: 8px;
  padding-top: 0px;
  padding-bottom: 6px;
  max-width: 467px;
  color: #000 !important;
  padding-right: 8px;
  margin-top: 15px !important;
}

.knpk-yellow {
  border-radius: 35px;
  text-align: center;
  max-width: 390px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
  font-size: 24px;
  padding: 15px 30px;
  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  /*text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);*/
  margin-top: 90px;
}

.knpk-yellow:hover {
  background: #fbfe00;
}

.knpk-yellow a {
  color: #000;
}

.gradyelblue{
  background-image: url(~@/assets/hometeacher/images/gradyelblue.png);
  max-width: 594px; max-height: 164px; padding-left: 10px;    padding-bottom: 5px;
}
.gradyelblue p {font-size: 25px;
  line-height: 1.6;
  color: #000;}

.oformite {
  background-image: url(~@/assets/hometeacher/images/oformite.png);
  padding-left: 8px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 7px;
}
.prodolz{display: none;}
.produman {
  padding-bottom: 0px;
  padding-top: 100px;
}

.produman h2 {
  /*
  font-family: Manrope Bold Alt;
  font-size: 40px;     color: #000;
  margin-top: 70px; margin-bottom: 40px;*/
}

.kak {
  background-image: url(~@/assets/hometeacher/images/kak-img.png);
  padding-left: 8px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 7px;
}

.kak-pr h2 {
  margin-top: 80px !important;
  margin-bottom: 70px !important;
}

.kakimg img {
  border-radius: 20px;
  margin-bottom: 40px;
  box-shadow: 7px 7px 12px rgb(0 0 0 / 20%);
}

.bluefon {
  font-size: 20px;
  background: #d0f4fe;
  padding: 30px 15px;
  color: #000;
  margin-right: -15px;
  margin-left: -15px;
  margin-top: 20px;
  margin-bottom: 20px;
}


.full {display: block;}
.liniya {
  background-image: url(~@/assets/hometeacher/images/liniya.png);
  width: 100%;
  height: 36px;
}
.groupzan {
  border: 2px solid #0493c3;
  padding: 10px 10px;
  border-radius: 30px;
  float: right;
  width: 285px;
  text-align: center;
}
.groupzan a {color: #0493c3;
  font-size: 20px;    font-weight: bold;
}


.zanat {
  max-height: 235px;
  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  border: 12px solid #e6eff2;
  border-radius: 10px;
}
.vidos {
  width:100%;
  height: 100%;
  border-radius: 15px;
  margin-right: 0px !important;
  margin-bottom: 100px !important;
}
.kakimg {margin-bottom: 20px;}

@media (max-width: 1366px) {
  .think img, .stars img {
    max-width: 100%;
  }
}

@media (max-width: 1280px) {
  .childs, .programmki {
    max-width: 100%;
  }

  .twokinds, .kakimg img, .produman img {
    max-width: 100%;
  }

  .birdskids {
    max-width: 100%;
    margin-left: 0px;
  }

  .childs {
    margin-right: -60px;
  }
  .prodolz{display: none;}

}
@media (max-width: 1200px) {
  .gradyelblue{max-height: 285px;}
}
@media (max-width: 1152px) {
  .childs {
    margin-right: -90px;
  }
  .par h2 {width:100%;}
  .knpk-yellow {font-size: 20px;}
  .knpk {
    margin-top: 30px;
  }
}

@media (max-width: 1024px) {
  .childs {
    margin-right: -30px;
    margin-top: -30px;
    max-width: 350px;
  }
  .clock-text{font-size: 23px !important;}
  .prodolz-1, .prodolz-2{
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    }
  .clock-img {
    right: 5px;
    left: auto;
  }

}

@media (max-width: 800px) {
    .knpk-yellow {
    text-align: center;
  }

  .greenfon h2 {
    font-size: 35px;
  }

}

@media (max-width: 575px) {
  .par, .small-strelki, .fon-krugi, .think, .stars, .sky-letter, .skyfon, .sky-clouds, .produman, .kak-pr {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .sky-letter h1 {
    font-size: 45px;
    line-height: 40px;
    margin-top: 35px;
  }
  .sky-letter h3 {margin-top: 20px;}

  .yellow-blue {
    font-size: 30px;
    background-image: url(~@/assets/hometeacher/images/yellow-blue-mob.png);
    padding-top: 2px;
    width: 247px;
    padding-bottom: 5px;
  }

  .breadcrumbs {
    margin-left: 0px;
    margin-top: 30px;
  }

  .childs {
    float: none;
    max-width: 100%;
    margin: 0px;
    margin-top: 20px;
  }

  .sky-clouds, .small-strelki, .fon-krugi, .think, .stars {
    background: none;
  }

  .small-strelki {
    padding-bottom: 40px;
  }
  .skytop{margin-bottom: -1px;}
  .skydown{margin-top: -1px;}

  .fon-krugi, .think {
    padding-top: 20px;
    padding-bottom: 50px
  }

  .twokinds, .birdskids {
    max-width: 70%;
    margin-top: 0px;
    float: none;
    margin-bottom: 20px;
  }

  .pdtop50px {
    padding-top: 0px;
  }

  .iba {
    font-size: 33px;
    line-height: 42px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .sdostavkoj {
    background-image: url(~@/assets/hometeacher/images/sdostavkoj-mob.png);
    padding-top: 2px;
    width: 227px;
    padding-bottom: 8px;
  }

  .pdlft80px {
    padding-left: 15px;
  }

  .gryelgrn {
    background-image: url(~@/assets/hometeacher/images/individ-fon-mob.png);
    padding-top: 3px;
  }

  .igraya {
    background-image: url(~@/assets/hometeacher/images/vibirajte-mob.png);
    padding-top: 2px;
    width: 240px;
    padding-bottom: 5px;
  }
  .chek {margin-left: 0px;}
  .sky-clouds p, .small-strelki p, .listochki p, .think p, .stars p, .produman p, .par p {
    margin-left: 35px;
  }
 .skyfon h2{font-size: 25px;}
 .skyfon img {display: none;}


  .uvlek {
    background-image: url(~@/assets/hometeacher/images/otprostogo-mob.png);
    padding-bottom: 8px;
    padding-top: 0px;
    line-height: 1.2;
    width:241px;
    height: 86px;
  }

  .programmki {
    margin-top: 0px;
  }

  .think img {
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .stars {
    margin-top: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .otkritost {
    background: url(~@/assets/hometeacher/images/otkrit-mob.png) no-repeat center top;
    padding-left: 10px;
    padding-top: 1px;
    width:257px;
    height:84px;
  }

  .bezlimit {
    background: url(~@/assets/hometeacher/images/naviki-mob.png) no-repeat center top;
    padding-left: 7px;
    padding-right: 8px;
    padding-top: 3px;
    width:264px; height:45px;
  }

.gradyelblue{
  background-image: url(~@/assets/hometeacher/images/gradyelblue-mob.png);
  max-width: 291px; max-height: 364px; padding-left: 10px;    padding-bottom: 5px;
}

  .stars img {
    margin-bottom: 30px;
    margin-top: 10px;
  }

  .greenfon h2 {
    font-size: 25px;
  }

  .greenfon img {
    display: none;
  }

  .veselo {
    background-image: url(~@/assets/hometeacher/images/veselo-sky-mob.png);
    padding-bottom: 4px;
    padding-left: 4px;
    padding-top: 1px;
    padding-right: 5px;
  }

  .knpk-yellow {
    font-size: 20px;
    padding: 20px 9px;
    max-width: 100%;
    margin-top: 40px;
    margin-bottom: 50px;
  }

  .produm {
    background-image: url(~@/assets/hometeacher/images/produm-mob.png);
    padding-bottom: 10px;
  }

  .kak-pr h2 {
    margin-top: 5px !important;
    margin-bottom: 35px !important;
  }

  .kak {
    background-image: url(~@/assets/hometeacher/images/kak-img-mob.png);
    padding-bottom: 10px;
  }
  .personal{
    background-image: url(~@/assets/hometeacher/images/personal-mob.png);
    width: 293px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .oformite {
    background-image: url(~@/assets/hometeacher/images/oformite-mob.png);
    width:206px; height: 125px;
    margin-top: 1px;
  }
  .produman{padding-top: 0px; padding-bottom: 70px;}
  .zanat {max-height: 225px;}

}
@media (max-width: 480px) {
  .zanat {max-height: 180px;}
}
@media (max-width: 450px) {
  .zanat {max-height: 170px;}
  .full {display: none;}
  .prodolz{background-image: url(~@/assets/hometeacher/images/prodolz.png);
    width:304px; height: 225px; padding-left: 8px; display: block;
  }
  .clock-text{font-size: 25px !important; line-height: 1.5;}
  .clock-img {top:180px;}
}

@media (max-width: 400px) {


}

@media (max-width: 390px) {
  .zanat {max-height: 145px;}
}
</style>
